import adminLevelsTypes from './types';

// Fetch Admin levels
export const fetchLevels = () => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVELS_REQUEST,
  payload: null,
});
export const fetchLevelsSuccess = (payload) => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVELS_SUCCESS,
  payload,
});
export const fetchLevelsFailure = (payload) => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVELS_FAILURE,
  payload,
});

// Fetch Admin levels
export const fetchLevelItems = () => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVEL_ITEMS_REQUEST,
  payload: null,
});
export const fetchLevelItemsSuccess = (payload) => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVEL_ITEMS_SUCCESS,
  payload,
});
export const fetchLevelItemsFailure = (payload) => ({
  type: adminLevelsTypes.FETCH_ADMIN_LEVEL_ITEMS_FAILURE,
  payload,
});

// add Admin Levels
export const addAdminLevel = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_REQUEST,
  data: payload,
});
export const addAdminLevelSuccess = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_SUCCESS,
  payload,
});
export const addAdminLevelFailure = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_FAILURE,
  payload,
});

// Update Admin Levels
export const updateAdminLevel = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_REQUEST,
  data: payload,
});
export const updateAdminLevelSuccess = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_SUCCESS,
  payload,
});
export const updateAdminLevelFailure = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_FAILURE,
  payload,
});

// DELETE Admin Levels
export const deleteAdminLevel = (payload) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_REQUEST,
  data: payload,
});
export const deleteAdminLevelSuccess = (payload) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_SUCCESS,
  payload,
});
export const deleteAdminLevelFailure = (payload) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_FAILURE,
  payload,
});

// add Admin Levels
export const addAdminLevelItemData = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_REQUEST,
  data: payload,
});
export const addAdminLevelItemDataSuccess = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_SUCCESS,
  payload,
});
export const addAdminLevelItemDataFailure = (payload) => ({
  type: adminLevelsTypes.ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_FAILURE,
  payload,
});

// add Admin Levels
export const updateAdminLevelItemData = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_ITEMS_DATA_REQUEST,
  data: payload,
});
export const updateAdminLevelItemDataSuccess = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS,
  payload,
});
export const updateAdminLevelItemDataFailure = (payload) => ({
  type: adminLevelsTypes.UPDATE_ADMIN_LEVEL_ITEMS_DATA_FAILURE,
  payload,
});

// DELETE Admin Level Item
export const deleteAdminLevelItem = (data, cb) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_REQUEST,
  payload: { data, cb },
});
export const deleteAdminLevelItemSuccess = (payload) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS,
  payload,
});
export const deleteAdminLevelItemFailure = (payload) => ({
  type: adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_FAILURE,
  payload,
});
